import React from 'react';
import { ProductStates } from '../../product-state-machine/product-state-machine-types';
import { ResultIcon } from './result-icon';
import { ResultAvatar } from '../../../common/result-avatar';
import { defaultResultRenderer } from '../../../extensible/search-result/default-result-renderer';

/**
 * This function renders a component search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export const componentResultRenderer = args => {
  var _searchResult$icon$to, _searchResult$icon;
  const {
    productState,
    searchResult
  } = args;
  const iconSize = productState === ProductStates.PreQuerySuccess ? 'small' : 'medium';
  const iconType = (_searchResult$icon$to = (_searchResult$icon = searchResult.icon) === null || _searchResult$icon === void 0 ? void 0 : _searchResult$icon.toString()) !== null && _searchResult$icon$to !== void 0 ? _searchResult$icon$to : '';
  return defaultResultRenderer({
    ...args,
    searchResult: {
      ...searchResult,
      icon: /*#__PURE__*/React.createElement(ResultIcon, {
        type: iconType,
        size: iconSize
      })
    }
  });
};

/**
 * This function renders a people or team search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export const peopleAndTeamsResultRenderer = args => {
  const {
    productState,
    searchResult
  } = args;
  const iconSize = productState === ProductStates.PreQuerySuccess ? 'xsmall' : 'small';
  return defaultResultRenderer({
    ...args,
    searchResult: {
      ...searchResult,
      icon: /*#__PURE__*/React.createElement(ResultAvatar, {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: iconSize,
        testId: "result-avatar"
      })
    }
  });
};